import { useContext, useEffect, useState } from 'react';
import { Alert, Box, Button, Card, Chip, CircularProgress, Stack, Typography } from '@mui/joy';
import { useNavigate } from 'react-router';
import { LayoutContext } from '../../context';
import { APIGetMockForms } from '../../api';

export default function MockExamsPage() {
    const { token } = useContext(LayoutContext);
    const navigate = useNavigate();
    const [forms, setForms] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        let mounted = true;
        APIGetMockForms(token)
            .then((data) => { if (mounted) setForms(data.forms || []); })
            .catch((err) => {
                if (mounted) setError(err.response?.data?.error || 'Не удалось загрузить пробники');
            })
            .finally(() => { if (mounted) setLoading(false); });
        return () => { mounted = false; };
    }, [token]);

    return (
        <Box sx={{ maxWidth: 1100, mx: 'auto', p: { xs: 2, md: 5 } }}>
            <Typography level="h1" sx={{ mb: 1 }}>Пробники</Typography>
            <Typography level="body-md" sx={{ mb: 4, color: 'text.secondary' }}>
                Полные экзаменационные формы с таймером, блоками и результатом после завершения.
            </Typography>

            {error && <Alert color="danger" sx={{ mb: 3 }}>{error}</Alert>}
            {loading && <CircularProgress />}
            {!loading && !error && forms.length === 0 && (
                <Card variant="outlined">
                    <Typography level="title-lg">Пробники пока готовятся</Typography>
                    <Typography level="body-sm" sx={{ color: 'text.secondary' }}>
                        Опубликованные формы появятся здесь после финальной проверки.
                    </Typography>
                </Card>
            )}
            {!loading && !error && forms.length > 0 && (
                <Stack direction={{ xs: 'column', sm: 'row' }} flexWrap="wrap" gap={2}>
                    {forms.map((form) => (
                        <Card key={form.slug} variant="outlined" sx={{ flex: '1 1 300px', maxWidth: { sm: 360 } }}>
                            <Stack direction="row" justifyContent="space-between" alignItems="center" gap={1}>
                                <Typography level="h3">{form.title}</Typography>
                                <Chip color="success" size="sm">Опубликован</Chip>
                            </Stack>
                            <Typography level="body-sm" sx={{ color: 'text.secondary', mt: 1 }}>
                                {form.total_questions} вопросов · {form.blocks?.length || 4} блока по 60 минут
                            </Typography>
                            <Button sx={{ mt: 3 }} onClick={() => navigate(`/mock-exams/${form.slug}`)}>
                                Начать пробник
                            </Button>
                        </Card>
                    ))}
                </Stack>
            )}
        </Box>
    );
}
